import CommonSlider from '../CommonSlider'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function FourthSlider({ sliderData = [] }) {
    if (!sliderData.length) return null;

    return (
        <>
            <div
                className="delivery_restaurant_header"
            >
                <h2>Moderately Priced</h2>
            </div>

            <div className="mt--60 mb-5">
                <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    loop={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    navigation={true}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        992: { slidesPerView: 2 },
                        1400: { slidesPerView: 3 },
                    }}
                    className="restaurent-swiper mt-0"
                >
                    {sliderData.map((item, index) => (
                        <SwiperSlide className="col-lg-6 col-md-12" key={item.id || index}>
                            <CommonSlider sliderData={item} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </>
    );
}

